import { render, staticRenderFns } from "./VisualCards.vue?vue&type=template&id=42d3349b&scoped=true&"
import script from "./VisualCards.vue?vue&type=script&lang=js&"
export * from "./VisualCards.vue?vue&type=script&lang=js&"
import style0 from "./VisualCards.vue?vue&type=style&index=0&id=42d3349b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d3349b",
  null
  
)

export default component.exports